import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  Aangifte, BokkzAlgDataService,
  IncomeTaxEntity,
  JaarrekeningBalans,
  OmschrijvingEnBedrag,
  Onderneming
} from '@snelstart-ventures/fiscaal/domain-logic';
import { BehaviorSubject, filter, Subscription } from 'rxjs';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BokkzIbDataService } from '@snelstart-ventures/fiscaal/domain-logic';
import { Event, NavigationEnd, Router } from '@angular/router';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiAlertModule } from '@snelstart/ui-alert';
import { CommonModule, DecimalPipe } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-egalisatiereserve',
  templateUrl: './spec-egalisatiereserve.component.html',
  imports: [
    SharedUiButtonModule,
    SharedUiDialogModule,
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiAlertModule,
    DecimalPipe,
    CommonModule
  ],
  styleUrls: ['./spec-egalisatiereserve.component.scss']
})
export class SpecEgalisatiereserveComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  private isSaving = false;
  @Input() public id!: string;
  public clientId!: string;
  aangifte = {} as Aangifte;
  public incomeTaxEntity = {} as IncomeTaxEntity;
  public partnerBoolean = {} as boolean;
  @Input() partner = new BehaviorSubject<boolean>(false);
  public currentAangifte = {} as Aangifte;
  public partnerAangifte = {} as Aangifte;

  public showSpinner = true;
  public focusedElementId: string | null = null;
  public dialogVisible = false;

  public ondernemingFG: FormGroup;
  public specEgalisatiereserveFG = {} as FormGroup;
  public formStructure: any;
  public ondernemingLength: any;

  showDialog() {
    this.dialogVisible = true;
  }

  constructor(private fb: FormBuilder,
              private router: Router,
              public dataService: BokkzIbDataService, private dataAlgService: BokkzAlgDataService) {
    this.ondernemingFG = this.fb.group({
      ondernemingen: this.fb.array([])
    });
    this.specEgalisatiereserveFG = this.fb.group<JaarrekeningBalans>({
      waardeOpening: null as unknown as number,
      waardeSlot: null as unknown as number
    });

  }

  //onderneming
  get ondernemingen(): FormArray {
    return this.ondernemingFG.get('ondernemingen') as FormArray;
  }

  createOndernemingFormGroup(onderneming?: Onderneming) {
    return this.dataService.createOndernemingFormGroup(onderneming);
  }

  // specificatie beginstandKER
  getBeginstandKER(index: number): FormArray {
    const outerGroup = this.ondernemingen.at(index) as FormGroup;
    return outerGroup.get('beginstandEgalisatiereserve') as FormArray;
  }

  addBeginstandKER(index: number): void {
    const innerGroup = this.fb.group<OmschrijvingEnBedrag>({
      omschrijving: '',
      bedrag: undefined as unknown as number

    });
    const outerGroup = this.ondernemingen.at(index) as FormGroup;
    const innerArray = outerGroup.get('beginstandEgalisatiereserve') as FormArray;
    innerArray.push(innerGroup);
  }

  deleteBeginstandKER(outerIndex: number, innerIndex: number): void {
    const innerArray = this.getBeginstandKER(outerIndex);
    innerArray.removeAt(innerIndex);
    this.saveForm();
  }

  createBeginstandKERFG(item?: OmschrijvingEnBedrag): FormGroup {
    return this.fb.group<OmschrijvingEnBedrag>({
      omschrijving: item ? item.omschrijving : null as unknown as string,
      bedrag: item ? item.bedrag : null as unknown as number
    });
  }

  getTotaal(): number {
    const start = this.specEgalisatiereserveFG.get('waardeOpening')?.getRawValue() || 0;
    let dotatie = 0;
    let onttrekking = 0;
    this.subscriptions.add(this.partner.subscribe((partner) => {
      if (!partner) {
        dotatie = this.aangifte.box1?.winstUitOnderneming?.ondernemingen[0].dotatieEgalisatiereserve || 0;
        onttrekking = this.aangifte.box1?.winstUitOnderneming?.ondernemingen[0].vrijvalEgalisatiereserve || 0;
      } else {
        dotatie = this.aangifte.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0].dotatieEgalisatiereserve || 0;
        onttrekking = this.aangifte.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0].vrijvalEgalisatiereserve || 0;
      }
    }));
    const einde = this.specEgalisatiereserveFG.get('waardeSlot')?.getRawValue() || 0;
    const result = start + dotatie - onttrekking - einde;
    return Math.abs(result);
  }

  getTotaalOpening(index: number): number {
    const beginstandKERArray = this.getBeginstandKER(index).controls;
    let totaal = 0;

    for (const control of beginstandKERArray) {
      const bedrag = control.get('bedrag')?.getRawValue() || 0;
      if (typeof bedrag === 'number') {
        totaal += bedrag;
      }
    }
    return totaal;
  }

  getVerschilOpening(): number {
    const totaalSpec = this.getTotaalOpening(0) || 0;
    const start = this.specEgalisatiereserveFG.get('waardeOpening')?.getRawValue() || 0;
    const result = totaalSpec - start;
    return Math.abs(result);
  }

  ngOnInit(): void {
    this.subscriptions.add(this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
      this.incomeTaxEntity = incomeTaxEntity;
      if (incomeTaxEntity.aangifte) {
        const aangifte = incomeTaxEntity.aangifte as Aangifte;
        this.aangifte = aangifte;
        this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
        this.updateForm();
        this.subscriptions.add(this.partner.subscribe((boolean) => {
          this.partnerBoolean = boolean;
          this.ondernemingFG.reset();
          this.specEgalisatiereserveFG.reset();
          this.updateForm();
        }));
        this.subscriptions.add(this.ondernemingFG.valueChanges.subscribe(value => {
          this.formStructure = value;
        }));
        this.subscriptions.add(this.ondernemingen.valueChanges.subscribe(value => {
          this.ondernemingLength = value;
        }));
      }
    }));
    this.subscriptions.add(this.dataAlgService.client.subscribe((client) => {
      this.clientId = client.sstRelationId!;
    }));
    this.subscriptions.add(this.router.events.pipe(filter(
      (event: Event): event is NavigationEnd =>
        event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.handleUrlChange(event.urlAfterRedirects);
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.ondernemingFG.dirty || this.specEgalisatiereserveFG.dirty;
  }


  private updateForm(): void {
    let ondernemingenLijst = this.aangifte?.box1?.winstUitOnderneming?.ondernemingen || [];
    this.subscriptions.add(this.partner.subscribe((partner) => {
      if (partner) {
        ondernemingenLijst = this.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen || [];
      }
      const onderneming = !partner ? this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0] : this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen[0];
      if (onderneming) {
        const egalisatieReserve = onderneming?.eigenVermogen?.filter(item => item !== null).find(item => item.omschrijving === 'egalisatieReserve') as JaarrekeningBalans;
        this.specEgalisatiereserveFG.patchValue(egalisatieReserve);
      }
    }));
    const formArray = this.ondernemingFG.get('ondernemingen') as FormArray;
    const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;
    while (formArray.length > ondernemingenLijst.length) {
      formArray.removeAt(formArray.length - 1);
    }

    // Update ondernemingen
    for (let i = 0; i < ondernemingenLijst.length; i++) {
      if (i < formArray.length) {
        const control = formArray.at(i) as FormGroup;
        control.patchValue(ondernemingenLijst[i]);
      } else {
        const formGroup = this.createOndernemingFormGroup(ondernemingenLijst[i]);
        formArray.push(formGroup);
      }
    }

    // Update beginstandKER
    for (let i = 0; i < ondernemingenLijst.length; i++) {
      const onderneming = ondernemingenLijst[i];
      const beginstandKER = onderneming.beginstandEgalisatiereserve || [];
      const beginstandKERFormArray = this.getBeginstandKER(i);
      while (beginstandKERFormArray.length > beginstandKER.length) {
        beginstandKERFormArray.removeAt(beginstandKERFormArray.length - 1);
      }
      for (let k = 0; k < beginstandKER.length; k++) {
        if (k < beginstandKERFormArray.length) {
          const control = beginstandKERFormArray.at(k) as FormGroup;
          control.patchValue(beginstandKER[k]);
        } else {
          const ker = this.createBeginstandKERFG(beginstandKER[k]);
          beginstandKERFormArray.push(ker);
        }
      }
    }

    if (focusedControl && document.contains(focusedControl)) {
      focusedControl.focus();
    }
  }

  saveForm(): void {
    setTimeout(() => {
      this.partner.subscribe((partner) => {
        if (!partner) {
          this.incomeTaxEntity.aangifte = {
            ...this.aangifte,
            box1: {
              winstUitOnderneming: {
                ...this.aangifte.box1?.winstUitOnderneming,
                ondernemingen: this.ondernemingFG.getRawValue().ondernemingen
              }
            }
          } as Aangifte;
          this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        } else {
          this.incomeTaxEntity.aangifte = {
            ...this.aangifte,
            partnerAangifte: {
              ...this.aangifte.partnerAangifte,
              box1: {
                winstUitOnderneming: {
                  ...this.aangifte.partnerAangifte?.box1?.winstUitOnderneming,
                  ondernemingen: this.ondernemingFG.getRawValue().ondernemingen
                }
              }
            }
          } as Aangifte;
          this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }
      });
    }, 0);
  }

  public heeftOndernemingen(): boolean {
    if (this.partnerBoolean) {
      return !!(this.incomeTaxEntity &&
        this.incomeTaxEntity.aangifte?.partnerAangifte &&
        this.incomeTaxEntity.aangifte?.partnerAangifte.box1 &&
        this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming &&
        this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming.ondernemingen &&
        this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming.ondernemingen.length > 0);
    } else {
      return !!(this.incomeTaxEntity &&
        this.incomeTaxEntity.aangifte?.box1 &&
        this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming &&
        this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming.ondernemingen &&
        this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming.ondernemingen.length > 0);
    }
  }

  getTotaalBedragen(): number {
    let totaal = 0;
    const ondernemingenArray = this.ondernemingFG.get('ondernemingen') as FormArray;

    ondernemingenArray.controls.forEach((ondernemingControl: AbstractControl) => {
      const beginstandKERArray = (ondernemingControl.get('beginstandEgalisatiereserve') as FormArray).controls;

      beginstandKERArray.forEach((hirControl: AbstractControl) => {
        const bedrag = hirControl.get('bedrag')?.getRawValue() || 0;
        totaal += bedrag;
      });
    });

    return totaal;
  }


}

